import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { sendGAEvent } from '@next/third-parties/google';

export const PageViewTracker = () => {
  const router = useRouter();

  useEffect(() => {
    const handleRouteChange = (url) => {
      console.log(`Sending pageview event for URL: ${url}`);

      sendGAEvent({ event: 'pageview', page: url });
    };

    // Send initial pageview event
    handleRouteChange(router.asPath);

    // Listen for route changes and send pageview event
    const handleRouteChangeComplete = (url) => {
      handleRouteChange(url);
    };

    router.events.on('routeChangeComplete', handleRouteChangeComplete);

    // Cleanup function
    return () => {
      console.log("Unsubscribing from route change events");

      router.events.off('routeChangeComplete', handleRouteChangeComplete);
    };
  }, [router]);

  return null;
};



export const trackCustomEvent = (eventAction, eventCategory, eventLabel) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventAction, {
      event_category: eventCategory,
      event_label: eventLabel
    });
    console.log("Google Analytics event sent:", eventAction,eventCategory,eventLabel);

  }
};
export const trackEpisodeImpression = (episodeId) => {
  trackCustomEvent('impression', 'Episode Impressions', `Episode ID: ${episodeId}`);
};



export const TrackEpisodeImpressions = ({ episodes }) => {
  const router = useRouter();

  useEffect(() => {
    const trackImpressions = () => {
      if (episodes) {
        episodes.forEach((episode) => {
          trackEpisodeImpression(episode._id); // Assuming _id is the correct property for episode ID
        });
      }
    };
  
    // Call trackImpressions when the component mounts
    trackImpressions();
  
    // Subscribe to route changes and track episode impressions
    const handleRouteChange = () => {
      trackImpressions();
    };
  
    router.events.on('routeChangeComplete', handleRouteChange);
  
    // Clean up subscription on unmount
    return () => {
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, [router, episodes]);
  // Render episode list
};

export const trackClickEvent = (eventCategory, eventLabel) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'click', {
      event_category: eventCategory,
      event_label: eventLabel
    });
    console.log("Google Analytics click event sent:", eventCategory, eventLabel);
  }
};